<template>
  <div class="mobile right-chenghao-container" :class="props.keyName">
    <div class="name-wrap">
      <div class="name" :class="locale">
        {{ $t(`mwr.stats.chenghao.${props.keyName}`) }}
      </div>
      <div class="name-desc">
        [{{ $t(`mwr.stats.chenghaoDesc.${props.keyName}`) }}]
      </div>
    </div>
    <div class="img-wrap" :class="props.keyName">
      <div class="img" :class="props.keyName"></div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { defineProps, inject } from 'vue'
import { useI18n } from 'vue-i18n'
const { locale } = useI18n()
const mwrData = inject('mwrData')
const { t } = useI18n()
const props = defineProps({
  keyName: {
    type: String,
    required: true
  }
})
// const getChenghaoName = () => {
//   if (!['modeID', 'weaponType'].includes(props.keyName)) {
//     return t(`mwr.stats.chenghao.${props.keyName}`)
//   }
//   return props.keyName
// }
</script>

<style lang="less" scoped src="./mobile_style.less"></style>